import { BuilderConfig } from '../../../types/Builder';

import B2BHubFAQ, { B2BFAQProps } from './b2b-faq';

export const B2BFAQBuilderConfig = {
    name: 'B2B FAQ',
    inputs: [
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'question',
                    type: 'html',
                },
                {
                    name: 'answer',
                    type: 'html',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<B2BFAQProps> = {
    component: B2BHubFAQ,
    config: B2BFAQBuilderConfig,
};

export default builderConfig;
